import { useEffect, useState } from "react";
import { Drawer } from "@stonelog/stonelog-design-system";
import FilterDrawer from "./FilterDrawer";
import LegendDrawer from "./LegendDrawer";
import SearchDrawer from "./SearchDrawer";
import DeliveryDrawer from "./DeliveryDrawer";
import DetailsDeliveryContent from "./DeliveryDrawer/DetailsDeliveryContent";
import { GingaIcon } from "@stonelog/stonelog-ginga-icons";
import { routesManagementSelector, setFlagOpenTrackDeliveries, setFlagOpenTrackDeliveriesAutonomos } from "../../../../../../features/senninha/routesManagementSlice";
import { useSelector, useDispatch } from "react-redux";
import { hubsSelector } from "../../../../../../features/senninha/hubsSlice";
import DetailsDeliveryPreBContent from "./DeliveryDrawer/DetailsDeliveryPreBContent";
import DetailsDeliveryAutonomosContent from "./DeliveryDrawer/DetailsDeliveryAutonomosContent";
import FinishedAutonomosContent from "./DeliveryDrawer/FinishedAutonomosContent";
import { pinsSelector, setBuildFilters } from "../../../../../../features/senninha/pinsSlice";

import * as S from "./styles";


const LeftMenuDrawers = ({
    open,
    setOpen,
    setDrawerSelected,
    drawerSelected
}) => {
    const [detailsDeliveryDrawer, setDetailsDeliveryDrawer] = useState(false)
    const [deliveryDetails, setDeliveryDetails] = useState()
    const [detailsDeliveryPreBDrawer, setDetailsDeliveryPreBDrawer] = useState(false)
    const [deliveryPreBaixadaDetails, setDeliveryPreBaixadaDetails] = useState()
    const [detailsDeliveryAutonomosDrawer, setDetailsDeliveryAutonomosDrawer] = useState(false)
    const [deliveryAutonomosDetails, setDeliveryAutonomosDetails] = useState()

    const { flagOpenTrackDeliveries, flagOpenTrackDeliveriesAutonomos } = useSelector(routesManagementSelector);
    const { pins, leftOpenDrawer } = useSelector(pinsSelector);

    const {
        selectedHubInfos
    } = useSelector(hubsSelector);

    const dispatch = useDispatch();

    const titleToggler = {
        'legend': 'Legenda',
        'filter': 'Filtrar por',
        'search': 'Buscar por',
        'delivery': 'Deliveries',
        'autonomos': 'Autônomos'
    }

    const onOpenDeliveryDrawer = (deliveryData) => {
        setDeliveryDetails(deliveryData)
        setDetailsDeliveryDrawer(true)
    }

    const onOpenDeliveryPreBaixadaDrawer = (deliveryData) => {
        setDeliveryPreBaixadaDetails(deliveryData)
        setDetailsDeliveryPreBDrawer(true)
    }

    const onOpenDeliveryAutonomosDrawer = (deliveryData) => {
        setDeliveryAutonomosDetails(deliveryData)
        setDetailsDeliveryAutonomosDrawer(true)
    }

    useEffect(() => {
        if (flagOpenTrackDeliveries) {
            setDrawerSelected('delivery')
            setOpen(true)
            dispatch(setFlagOpenTrackDeliveries(false))
        }
    }, [flagOpenTrackDeliveries])

    useEffect(() => {
        if (flagOpenTrackDeliveriesAutonomos) {
            setDrawerSelected('autonomos')
            setOpen(true)
            dispatch(setFlagOpenTrackDeliveriesAutonomos(false))
        }
    }, [flagOpenTrackDeliveriesAutonomos])

    useEffect(() => {
        if (pins) {
            const uniqueAngels = [];
            pins.forEach(pin => {
                if (!uniqueAngels.includes(pin.angel)) {
                    uniqueAngels.push(pin.angel);
                }
            });

            // Mostra apenas os pins com os angels embaixo
            const filteredAngels = uniqueAngels.filter(
                angel =>
                    angel == "Vencimento futuros (Não alocadas)" ||
                    angel == "Vencidas (Não alocadas)" ||
                    angel == "Vencem hoje (Não alocadas)"
            );

            if (leftOpenDrawer === false) {
                dispatch(setBuildFilters(filteredAngels.map(angel => ({ field: 'angel', value: angel, drawer: 'legenda' }))));
            }
        }
    }, [pins]);

    return (

        <S.InsideDrawerContent>
            <Drawer.Root
                title={
                    <Drawer.Header
                        title={titleToggler[drawerSelected]}
                        subTitle={['Deliveries', 'Autônomos'].includes(titleToggler[drawerSelected]) ? "Você pode acompanhar detalhes de cada delivery clicando sobre ela." : ''}
                    />
                }
                placement="left"
                open={open}
                getContainer={false}
                onClose={() => setOpen(false)}
            >
                {
                    drawerSelected === 'legend' && (
                        <LegendDrawer />
                    )
                }
                {
                    drawerSelected === 'filter' && (
                        <FilterDrawer />
                    )
                }
                {
                    drawerSelected === 'search' && (
                        <SearchDrawer />
                    )
                }
                {
                    drawerSelected === 'delivery' && (
                        <DeliveryDrawer
                            onOpenDeliveryDrawer={onOpenDeliveryDrawer}
                            onOpenDeliveryPreBaixadaDrawer={onOpenDeliveryPreBaixadaDrawer}
                        />
                    )
                }
                {
                    drawerSelected === 'autonomos' && (
                        <FinishedAutonomosContent
                            onOpenDeliveryAutonomosDrawer={onOpenDeliveryAutonomosDrawer}
                        />
                    )
                }
            </Drawer.Root>

            <Drawer.Root
                placement="left"
                open={detailsDeliveryDrawer}
                getContainer={false}
                closeIcon={null}
                title={
                    <Drawer.Header
                        className="ginga-lib-drawer-header"
                        subTitle={
                            <S.ButtonStyled
                                solid
                                size='small'
                                width="36px"
                                onClick={() => {
                                    // dispatch(getTrackingDeliveries(selectedHubInfos.children))
                                    setDetailsDeliveryDrawer(false)
                                }}
                            >
                                <GingaIcon name="chevron-left" color='black' />
                            </S.ButtonStyled>
                        }
                    />
                }
            >
                <DetailsDeliveryContent
                    open={detailsDeliveryDrawer}
                    onClose={() => {
                        setDetailsDeliveryDrawer(false)
                    }}
                    data={deliveryDetails}
                />
            </Drawer.Root>

            <Drawer.Root
                placement="left"
                open={detailsDeliveryPreBDrawer}
                getContainer={false}
                closeIcon={null}
                title={
                    <Drawer.Header
                        className="ginga-lib-drawer-header"
                        subTitle={
                            <S.ButtonStyled
                                solid
                                size='small'
                                width="36px"
                                onClick={() => setDetailsDeliveryPreBDrawer(false)}
                            >
                                <GingaIcon name="chevron-left" color='black' />
                            </S.ButtonStyled>
                        }
                    />
                }
            >
                <DetailsDeliveryPreBContent
                    open={detailsDeliveryPreBDrawer}
                    onClose={() => {
                        setDetailsDeliveryPreBDrawer(false)
                    }}
                    data={deliveryPreBaixadaDetails}
                />
            </Drawer.Root>

            <Drawer.Root
                placement="left"
                open={detailsDeliveryAutonomosDrawer}
                getContainer={false}
                closeIcon={null}
                title={
                    <Drawer.Header
                        className="ginga-lib-drawer-header"
                        subTitle={
                            <S.ButtonStyled
                                solid
                                size='small'
                                width="36px"
                                onClick={() => setDetailsDeliveryAutonomosDrawer(false)}
                            >
                                <GingaIcon name="chevron-left" color='black' />
                            </S.ButtonStyled>
                        }
                    />
                }
            >
                <DetailsDeliveryAutonomosContent
                    open={detailsDeliveryAutonomosDrawer}
                    onClose={() => {
                        setDetailsDeliveryAutonomosDrawer(false)
                    }}
                    data={deliveryAutonomosDetails}
                />
            </Drawer.Root>
        </S.InsideDrawerContent>
    )
}

export default LeftMenuDrawers;
